require('/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/syncedfieldstable/syncedfieldstable.module.scss.module.css');

export const warningCallout = "_warning-callout_12p0t_1";
